import { render } from "./app-data-table-server-for-mobile.vue?vue&type=template&id=264be302"
import script from "./app-data-table-server-for-mobile.vue?vue&type=script&setup=true&lang=js"
export * from "./app-data-table-server-for-mobile.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./app-data-table-server-for-mobile.vue?vue&type=style&index=0&id=264be302&module=true&lang=scss"
cssModules["$style"] = style0
if (module.hot) {
  module.hot.accept("./app-data-table-server-for-mobile.vue?vue&type=style&index=0&id=264be302&module=true&lang=scss", () => {
    cssModules["$style"] = style0
    __VUE_HMR_RUNTIME__.rerender("264be302")
  })
}

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__file',"resources/js/common/shared/components/app-data-table-server-for-mobile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "264be302"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('264be302', __exports__)) {
    api.reload('264be302', __exports__)
  }
  
  module.hot.accept("./app-data-table-server-for-mobile.vue?vue&type=template&id=264be302", () => {
    api.rerender('264be302', render)
  })

}


export default __exports__